import {JSONContent} from "@tiptap/react";

const MARK_TAGS: Record<string, string> = {
    bold: "b",
    italic: "i",
    underline: "u",
    strike: "s",
};

export const escapeTelegramHtml = (text: string) =>
    text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

const serializeInline = (nodes: JSONContent[] = []) =>
    nodes
        .map(node => {
            if (node.type === "hardBreak") return "\n";
            if (node.type !== "text") return "";

            let out = escapeTelegramHtml(node.text ?? "");
            for (const mark of node.marks ?? []) {
                const tag = MARK_TAGS[mark.type];
                if (tag) out = `<${tag}>${out}</${tag}>`;
            }
            return out;
        })
        .join("");

export const toTelegramHtml = (doc: JSONContent): string =>
    (doc.content ?? []).map(p => serializeInline(p.content)).join("\n");

export const fromTelegramHtml = (html: string): string =>
    (html ?? "")
        .split("\n")
        .map(line => `<p>${line}</p>`)
        .join("");

export const telegramToPlainText = (html: string): string =>
    (html ?? "")
        .replace(/<[^>]+>/g, "")
        .replace(/&lt;/g, "<")
        .replace(/&gt;/g, ">")
        .replace(/&amp;/g, "&");

export const telegramTextLength = (html: string): number =>
    telegramToPlainText(html).length;

const ALLOWED_TAGS = new Set(["b", "i", "u", "s"]);

export const telegramToSafeHtml = (html: string): string =>
    (html ?? "").replace(/<(\/?)([a-z]+)[^>]*>/gi, (_, slash: string, tag: string) =>
        ALLOWED_TAGS.has(tag.toLowerCase()) ? `<${slash}${tag.toLowerCase()}>` : ""
    ).replace(/\r?\n/g, "<br>");